module.exports = __webpack_public_path__ + "static/img/primary.9f22930e.png";